import { Dialog, Drawer } from '@actualtysoft/ui-kit';
import { Box } from '@mui/material';
import { useModalStore } from 'stores/modal';

const Modal = (): JSX.Element => {
  const { show, title, component, type, closeModal } = useModalStore();
  if (type === 'dialog') {
    return (
      <Dialog open={show} onClose={closeModal} title={title}>
        <>{component}</>
      </Dialog>
    );
  }

  return (
    <Drawer
      disableEnforceFocus
      open={show}
      onClose={() => closeModal()}
      title={title}
    >
      <Box>{component}</Box>
    </Drawer>
  );
};

export default Modal;
